export default "__VITE_ASSET__rhUx9KL5__"